import {
  ImageActionType,
  ImageObjectFit,
  ImageSettings,
  SectionElement,
} from "@wuilt/section-preview";
import { nanoid } from "nanoid";
import { PointType } from "./Cropper/cropper-types";

export type ImageValueObject = {
  url: string;
  scalable: boolean;
  backgroundPosition: PointType;
  backgroundSize: PointType;
  zoom: number;
};

export type OldImageValue = string | ImageValueObject;

export type ImageSettingsExtended = ImageSettings & { id?: string };

function migrateSettings(
  id: string,
  old: OldImageValue
): ImageSettingsExtended {
  // has been migrated before
  if ((old as ImageSettingsExtended).desktop)
    return old as ImageSettingsExtended;

  const castedOld = old as ImageValueObject;

  return {
    id,
    desktop: {
      action: {
        type: castedOld?.scalable
          ? ImageActionType.Scale_Up
          : ImageActionType.Do_Nothing,
      },
      objectFit: ImageObjectFit?.Cover,
      src: castedOld?.url || (castedOld as unknown as string),
      crop: {
        backgroundPosition: castedOld?.backgroundPosition,
        backgroundSize: castedOld?.backgroundSize,
        zoom: castedOld?.zoom,
      },
    },
  };
}

export function migrateElement(id: string, old: OldImageValue): SectionElement {
  const settings = migrateSettings(id, old);

  return { id: id || `Image:${nanoid()}`, type: "Image", settings };
}
